import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ALL_CHAINS, getChainName, getStatusDisplay } from "../../../../anyspend/index.js";
import { Badge, useIsMobile } from "../../../../global-account/react/index.js";
import { cn } from "../../../../shared/utils/index.js";
import { formatTokenAmount } from "../../../../shared/utils/number.js";
import { getVendorDisplayName } from "../../../../shared/utils/payment.utils.js";
import { ArrowRight, Coins, Image } from "lucide-react";
import TimeAgo from "react-timeago";
export function OrderHistoryItem(t0) {
  const $ = _c(3);
  const {
    order,
    onSelectOrder,
    mode
  } = t0;
  const nft = order.type === "mint_nft" ? order.metadata.nft : undefined;
  const tournament = order.type === "join_tournament" || order.type === "fund_tournament" ? order.metadata.tournament : undefined;
  const dstToken = order.metadata.dstToken;
  const actualDstAmount = order.settlement?.actualDstAmount;
  const expectedDstAmount = order.type === "mint_nft" || order.type === "join_tournament" || order.type === "fund_tournament" || order.type === "custom" ? undefined : order.payload.expectedDstAmount;
  const {
    text: orderStatusText,
    status: orderDisplayStatus
  } = getStatusDisplay(order);
  const isSmallView = useIsMobile() || mode === "modal";
  const isOneClickPayment = !!order.oneClickBuyUrl;
  const vendorName = order.onrampMetadata?.vendor ? getVendorDisplayName(order.onrampMetadata.vendor) : null;
  let t1;
  if ($[0] !== onSelectOrder || $[1] !== order.id) {
    t1 = () => onSelectOrder?.(order.id);
    $[0] = onSelectOrder;
    $[1] = order.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return _jsxs("div", {
    className: cn("font-inter border-as-border-secondary border-b py-5 font-medium transition-all last:border-b-0", onSelectOrder && "hover:bg-as-surface-secondary/50 cursor-pointer"),
    onClick: t1,
    children: [_jsxs("div", {
      className: "mb-3 flex items-center justify-between",
      children: [_jsxs("div", {
        className: "flex items-center gap-2",
        children: [_jsx("div", {
          className: cn("text-xs", orderDisplayStatus === "processing" && "text-yellow-600", orderDisplayStatus === "success" && "text-green-600", orderDisplayStatus === "failure" && "text-red-600"),
          children: orderStatusText
        }), isOneClickPayment && vendorName && _jsx(Badge, {
          variant: "outline",
          className: "text-as-secondary px-2 py-0.5 text-[10px]",
          children: vendorName
        })]
      }), _jsx("div", {
        className: "text-as-secondary text-[10px] font-medium uppercase tracking-wide",
        children: _jsx(TimeAgo, {
          date: new Date(order.createdAt)
        })
      })]
    }), _jsxs("div", {
      className: cn("flex items-center", isSmallView ? "gap-2" : "gap-4"),
      children: [_jsxs("div", {
        className: cn("flex min-w-0 flex-1 items-center", isSmallView ? "gap-1.5" : "gap-2"),
        children: [order.metadata.srcToken.metadata.logoURI ? _jsx("img", {
          src: order.metadata.srcToken.metadata.logoURI,
          alt: order.metadata.srcToken.symbol,
          className: cn("shrink-0 rounded-full", isSmallView ? "h-7 w-7" : "h-8 w-8")
        }) : _jsx("div", {
          className: cn("flex shrink-0 items-center justify-center rounded-full bg-gray-200", isSmallView ? "h-7 w-7" : "h-8 w-8"),
          children: _jsx(Coins, {
            className: cn("text-gray-400", isSmallView ? "h-3.5 w-3.5" : "h-4 w-4")
          })
        }), _jsxs("div", {
          className: "min-w-0 flex-1",
          children: [_jsxs("div", {
            className: cn("text-as-primary truncate font-bold", isSmallView ? "text-xs" : "text-sm"),
            children: [formatTokenAmount(BigInt(order.srcAmount), order.metadata.srcToken.decimals), " ", order.metadata.srcToken.symbol]
          }), _jsxs("div", {
            className: cn("text-as-secondary flex items-center gap-1", isSmallView ? "text-[10px]" : "text-xs"),
            children: [_jsx("img", {
              src: ALL_CHAINS[order.srcChain]?.logoUrl,
              alt: getChainName(order.srcChain),
              className: "h-3 w-3"
            }), _jsx("span", {
              className: "truncate",
              children: getChainName(order.srcChain)
            })]
          })]
        })]
      }), _jsx(ArrowRight, {
        className: cn("text-as-secondary shrink-0 opacity-30", isSmallView ? "h-4 w-4" : "h-5 w-5")
      }), _jsx("div", {
        className: cn("flex min-w-0 flex-1 items-center", isSmallView ? "gap-1.5" : "gap-2"),
        children: nft ? _jsxs(_Fragment, {
          children: [nft.imageUrl ? _jsx("img", {
            src: nft.imageUrl,
            alt: nft.name,
            className: cn("shrink-0 rounded-full", isSmallView ? "h-7 w-7" : "h-8 w-8")
          }) : _jsx("div", {
            className: cn("flex shrink-0 items-center justify-center rounded-full bg-gray-200", isSmallView ? "h-7 w-7" : "h-8 w-8"),
            children: _jsx(Image, {
              className: cn("text-gray-400", isSmallView ? "h-3.5 w-3.5" : "h-4 w-4")
            })
          }), _jsxs("div", {
            className: "min-w-0 flex-1",
            children: [_jsx("div", {
              className: cn("text-as-primary truncate font-bold", isSmallView ? "text-xs" : "text-sm"),
              children: nft.name
            }), _jsxs("div", {
              className: cn("text-as-secondary flex items-center gap-1", isSmallView ? "text-[10px]" : "text-xs"),
              children: [_jsx("img", {
                src: ALL_CHAINS[order.dstChain]?.logoUrl,
                alt: getChainName(order.dstChain),
                className: "h-3 w-3"
              }), _jsx("span", {
                className: "truncate",
                children: getChainName(order.dstChain)
              })]
            })]
          })]
        }) : tournament ? _jsxs(_Fragment, {
          children: [tournament.imageUrl ? _jsx("img", {
            src: tournament.imageUrl,
            alt: tournament.name,
            className: cn("shrink-0 rounded-full", isSmallView ? "h-7 w-7" : "h-8 w-8")
          }) : _jsx("div", {
            className: cn("flex shrink-0 items-center justify-center rounded-full bg-gray-200", isSmallView ? "h-7 w-7" : "h-8 w-8"),
            children: _jsx(Image, {
              className: cn("text-gray-400", isSmallView ? "h-3.5 w-3.5" : "h-4 w-4")
            })
          }), _jsxs("div", {
            className: "min-w-0 flex-1",
            children: [_jsx("div", {
              className: cn("text-as-primary truncate font-bold", isSmallView ? "text-xs" : "text-sm"),
              children: tournament.name
            }), _jsxs("div", {
              className: cn("text-as-secondary flex items-center gap-1", isSmallView ? "text-[10px]" : "text-xs"),
              children: [_jsx("img", {
                src: ALL_CHAINS[order.dstChain]?.logoUrl,
                alt: getChainName(order.dstChain),
                className: "h-3 w-3"
              }), _jsx("span", {
                className: "truncate",
                children: getChainName(order.dstChain)
              })]
            })]
          })]
        }) : _jsxs(_Fragment, {
          children: [dstToken.metadata.logoURI ? _jsx("img", {
            src: dstToken.metadata.logoURI,
            alt: dstToken.symbol,
            className: cn("shrink-0 rounded-full", isSmallView ? "h-7 w-7" : "h-8 w-8")
          }) : _jsx("div", {
            className: cn("flex shrink-0 items-center justify-center rounded-full bg-gray-200", isSmallView ? "h-7 w-7" : "h-8 w-8"),
            children: _jsx(Coins, {
              className: cn("text-gray-400", isSmallView ? "h-3.5 w-3.5" : "h-4 w-4")
            })
          }), _jsxs("div", {
            className: "min-w-0 flex-1",
            children: [_jsxs("div", {
              className: cn("text-as-primary truncate font-bold", isSmallView ? "text-xs" : "text-sm"),
              children: [formatTokenAmount(actualDstAmount ? BigInt(actualDstAmount) : expectedDstAmount ? BigInt(expectedDstAmount) : BigInt(0), dstToken.decimals), " ", dstToken.symbol]
            }), _jsxs("div", {
              className: cn("text-as-secondary flex items-center gap-1", isSmallView ? "text-[10px]" : "text-xs"),
              children: [_jsx("img", {
                src: ALL_CHAINS[order.dstChain]?.logoUrl,
                alt: getChainName(order.dstChain),
                className: "h-3 w-3"
              }), _jsx("span", {
                className: "truncate",
                children: getChainName(order.dstChain)
              })]
            })]
          })]
        })
      })]
    })]
  }, `anyspend-${order.id}`);
}